import { FVError, FVErrorCode } from 'js/file_viewer/core/types/errors';
export function isFVError(e) {
    return e instanceof FVError;
}
export function getFvErrorCodeFromPreviewDataApi(error) {
    switch (error === null || error === void 0 ? void 0 : error['.tag']) {
        case 'unsupported_file_error':
            return FVErrorCode.UnsupportedPreviewType;
        case 'encrypted_file_error':
            return FVErrorCode.FileEncrypted;
        case 'content_not_uploaded':
            return FVErrorCode.FileUploading;
        default:
            return FVErrorCode.PreviewsDataApiFailure;
    }
}
//# sourceMappingURL=errors.preenvesnextjs.map
